const AllAreEmpty = (attr: Record<string, string>) =>
  Object.values(attr).every((value) => value === '');

const AnyIsEmpty = (attr: Record<string, string>) =>
  Object.values(attr).some((value) => value === '');

const AnyTrue = (state: any, attr: any[]) => !!attr.find((key) => !!state[key]);

const validationSchema = {
  new: {
    magicline: (state: any) =>
      AnyIsEmpty({
        selectedLocation: state.selectedLocation,
        baseUrl: state.baseUrl,
        apiKey: state.apiKey,
        webHookKey: state.webHookKey,
        startDate: state.startDate,
      }),
    eversports: (state: any) =>
      AnyIsEmpty({
        selectedLocation: state.selectedLocation,
        locationId: state.locationId,
        startDate: state.startDate,
      }),
    virtuagym: (state: any) =>
      AnyIsEmpty({
        selectedLocation: state.selectedLocation,
        clubId: state.clubId,
        startDate: state.startDate,
      }),
    zingfit: (state: any) =>
      AnyIsEmpty({
        selectedLocation: state.selectedLocation,
        startDate: state.startDate,
      }),
    virtuagymv1: (state: any) =>
      AnyIsEmpty({
        selectedLocation: state.selectedLocation,
        startDate: state.startDate,
      }),
    mindbody: (state: any) =>
      AnyIsEmpty({
        selectedLocation: state.selectedLocation,
        startDate: state.startDate,
        siteId: state.siteId,
        serviceId: state.serviceId,
      }),
    resamania: (state: any) =>
      AnyIsEmpty({
        selectedLocation: state.selectedLocation,
        startDate: state.startDate,
        studioId: state.studioId,
        networkId: state.networkId,
        clientToken: state.clientToken,
        clubID: state.clubID,
        countryCode: state.countryCode,
      }),
  },
  edit: {
    magicline: (state: any) =>
      AllAreEmpty({
        startDate: state.startDate,
        initialStartDate: state.initialStartDate,
      }) || state.channelUpdated,
    eversports: (state: any) =>
      AllAreEmpty({
        startDate: state.startDate,
        initialStartDate: state.initialStartDate,
      }) || state.channelUpdated,
    virtuagym: (state: any) =>
      AllAreEmpty({
        startDate: state.startDate,
        initialStartDate: state.initialStartDate,
      }) || state.channelUpdated,
    zingfit: (state: any) =>
      AllAreEmpty({
        startDate: state.startDate,
        initialStartDate: state.initialStartDate,
      }) || state.channelUpdated,
    virtuagymv1: (state: any) =>
      AllAreEmpty({
        startDate: state.startDate,
        initialStartDate: state.initialStartDate,
      }) || state.channelUpdated,
    mindbody: (state: any) =>
      AllAreEmpty({
        startDate: state.startDate,
        initialStartDate: state.initialStartDate,
      }) || state.channelUpdated,
    resamania: (state: any) =>
      AllAreEmpty({
        startDate: state.startDate,
        initialStartDate: state.initialStartDate,
      }) || state.channelUpdated,
  },
} as Record<string, Record<string, (state: any) => boolean>>;

interface IUseValidation {
  mode: string;
  integrationType: string;
  isLoading?: boolean;
  eversportsLoading?: boolean;
  updateChannelLoading?: boolean;
  virtuaGymLoading?: boolean;
  zingfitLoading?: boolean;
  virtuaGymV1Loading?: boolean;
  mindbodyLoading?: boolean;
  state: Record<string, any>;
  resamaniaLoading?: boolean;
}

export const useValidation = ({ mode, integrationType, ...state }: IUseValidation) => {
  let disabled = false;
  disabled = validationSchema?.[mode]?.[integrationType]?.(state) || false;
  if (
    !disabled &&
    AnyTrue(state, [
      'isLoading',
      'eversportsLoading',
      'updateChannelLoading',
      'virtuaGymLoading',
      'zingfitLoading',
      'virtuaGymV1Loading',
      'mindbodyLoading',
      'resamaniaLoading',
    ])
  ) {
    disabled = true;
  }

  return { disabled };
};
